export enum WORKSPACE_ROUTES {
  GET_ALL = "/workspace/settings",
  GET = "/workspace/settings/",
  CREATE = "/workspace/settings/create-workspace",
  UPDATE = "/workspace/settings/",
}
